
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.4312 4C18.9812 4 19.4312 4.45 19.4312 5V14H25.3C25.7437 14 25.9688 14.5375 25.6562 14.85L16.7063 23.825C16.3125 24.2188 15.6813 24.2188 15.2875 23.825L6.35 14.85C6.0375 14.5375 6.25625 14 6.70625 14H12.575V5C12.575 4.45 13.025 4 13.575 4H18.4312ZM18.4312 2H13.575C11.9187 2 10.575 3.34375 10.575 5V12H6.70625C4.4875 12 3.3625 14.6875 4.9375 16.2625L13.875 25.2375C15.05 26.4125 16.95 26.4125 18.125 25.2375L27.0688 16.2687C28.6375 14.7 27.525 12.0063 25.3 12.0063H21.4312V5C21.4312 3.34375 20.0812 2 18.4312 2ZM28 29.25V28.75C28 28.3375 27.6625 28 27.25 28H4.75C4.3375 28 4 28.3375 4 28.75V29.25C4 29.6625 4.3375 30 4.75 30H27.25C27.6625 30 28 29.6625 28 29.25Z"}}),_c('path',{attrs:{"d":"M18.4312 4C18.9812 4 19.4312 4.45 19.4312 5V14H25.3C25.7437 14 25.9688 14.5375 25.6562 14.85L16.7063 23.825C16.3125 24.2188 15.6813 24.2188 15.2875 23.825L6.35 14.85C6.0375 14.5375 6.25625 14 6.70625 14H12.575V5C12.575 4.45 13.025 4 13.575 4H18.4312Z"}})])
          )
        }
      }
    